"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var profile_service_1 = require('./service/profile.service');
var ProfileComponent = (function () {
    function ProfileComponent(profileService) {
        this.profileService = profileService;
        this.hasDataDumped = false;
    }
    ProfileComponent.prototype.ngOnInit = function () {
        this.username = sessionStorage.getItem('username');
        this.apiLink = "https://api.github.com/users/" + this.username;
        this.getUserInfo(this.apiLink);
    };
    ProfileComponent.prototype.ngDoCheck = function () {
        if (this.response && !this.hasDataDumped) {
            var data = this.response;
            this.avatar_url = data.avatar_url;
            this.blog_url = "https://" + data.blog;
            this.created = data.created;
            this.email = data.email;
            this.followers = data.followers;
            this.following = data.following;
            this.hireable = data.hireable;
            this.html_url = data.html_url;
            this.location = data.location;
            this.full_name = data.full_name;
            this.public_gists = data.public_gists;
            this.public_repo = data.public_repos;
            this.type = data.type;
            this.updated_at = data.updated_at;
            this.hasDataDumped = true;
        }
    };
    ProfileComponent.prototype.getUserInfo = function (link) {
        var _this = this;
        this.profileService.getProfileInfo(link)
            .subscribe(function (response) { return _this.response = response; }, function (error) { return _this.errorMessage = error; });
    };
    ProfileComponent.prototype.goToGithub = function (link) {
        window.location.assign(link);
    };
    ProfileComponent.prototype.goToBlog = function (link) {
        window.location.assign(link);
    };
    ProfileComponent = __decorate([
        core_1.Component({
            selector: 'user-profile',
            template: require('./templates/profile.component.html'),
            providers: [profile_service_1.ProfileService]
        }), 
        __metadata('design:paramtypes', [profile_service_1.ProfileService])
    ], ProfileComponent);
    return ProfileComponent;
}());
exports.ProfileComponent = ProfileComponent;
//# sourceMappingURL=profile.component.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/profile.component.js
 ** module id = 352
 ** module chunks = 0
 **/